<!-- <div class="login_container_center">

<div class="login-box">
  <div class="login_container text-white d-flex justify-content-center align-items-center">
    <h4>{{"Car has successfully Requested!" }} <img src="assets/img/Group 3724.png"/> </h4>
  </div>
  <div class="login-logo" style="height: 8vh;">
    <img src="assets/img/PASSValet.png" width='50%' style="margin-left: 13px !important;"/>
  </div>
  <div class="login-box-body">
    <form>
      <div>
        <table>
          <tbody>
            <tr>
              <td style="font-size: 14pt;">{{"Location" }}</td>
              <td style="font-size: 14pt;">{{"Requested Time" }}</td>
            </tr>
            <tr>
              <td><b style="font-size: 14pt;">{{vehicleDetails.valet_site?.title_en}}</b></td>
              <td><b style="font-size: 14pt;">{{vehicleDetails.requested_at_time}}</b></td>
            </tr>
          </tbody>
        </table>
        <h4 style="text-align: right; margin-top: 20px;"><b>Total <span style="color: #36BFEF;">SAR {{vehicleDetails.amount}}</span></b></h4>
      </div>
    </form>
  </div>
  <div class="col-xs-12" style="padding: 10%;">
        <button type="button" style="padding: 3%; 
        border-radius: 5px; font-size: 14pt;" (click)="payment()" class="btn btn-primary btn-block btn-flat">{{"Proceed to payment" }}</button>
  </div>
  <img src="assets/img/Image_86.png" width='15%' style="margin-left: 13px !important;"/>
  <img src="assets/img/Rectangle_5591.png" width='15%' style="margin-left: 13px !important;"/>
  <img src="assets/img/Rectangle_5592.png" width='15%' style="margin-left: 13px !important;"/>
  <img src="assets/img/Mask_Group_8.png" width='15%' style="margin-left: 13px !important;"/>
  <img src="assets/img/Image_88.png" width='15%' style="margin-left: 13px !important;"/>
</div>
</div> -->




<div class="login_container_center">

  <div class="flex-container">
    <img class="center-image" src="assets/img/link-logo.png" width="85" alt="" srcset="">
    @if (currentLanguage === 'eng') {
      <h4 class="right-text" (click)="changeLanguage('arb')">عربي</h4>
    }
    @if (currentLanguage === 'arb') {
      <h4 class="right-text" (click)="changeLanguage('eng')">English</h4>
    }
  </div>


  <div style="padding-left: 25px; padding-right: 25px; padding-top: 40px;">
    <div class="login_container text-white d-flex align-items-center justify-content-center">
      @if (currentLanguage === 'eng') {
        <h4>{{ currentTranslation.carRequested }} <img  src="assets/img/Group 3724.png"/> </h4>
      }
      @if (currentLanguage === 'arb') {
        <h4><img  src="assets/img/Group 3724.png"/> {{ currentTranslation.carRequested }}  </h4>
      }
    </div>

    <div style="background-color: white; border-radius: 4pt; padding: 15px 15px; margin: 20px 0px;">
      <img src="assets/img/riyadh-logo.png" width="50" style="margin: 10px 0;" alt="" srcset="">
      <table style="width: 100%;">
        <tbody>
          <tr>
            <td style=" width: 50%;">{{ currentTranslation.location }}</td>
            <td style=" width: 50%; text-align: end;">{{ currentTranslation.requestedTime }}</td>
          </tr>
          <tr>
            @if (currentLanguage === 'eng') {
              <td style=" width: 50%;   font-size: 12pt;"><b>{{vehicleDetails?.valet_site?.title_en}}</b></td>
            }
            @if (currentLanguage === 'arb') {
              <td style=" width: 50%;   font-size: 12pt;"><b>{{vehicleDetails?.valet_site?.title_ar}}</b></td>
            }
            <td style=" width: 50%;  text-align: end; font-size: 12pt;"><b>{{vehicleDetails?.requested_at_time}}</b></td>
          </tr>
        </tbody>
      </table>



      <table style="width: 100%; margin-top: 30px;">
        <tbody>
          <tr style="border-top: .5px solid black;border-bottom: .5px solid black;">
            <td style=" width: 50%;">{{ currentTranslation.description }}</td>
            <td style=" width: 50%; text-align: end;">{{ currentTranslation.amount }}</td>
          </tr>
          <tr>
            <td style=" width: 50%;   "><b>{{ currentTranslation.valetFees }}</b></td>
            <td style=" width: 50%;  text-align: end; font-size: 12pt;"><b>{{ currentTranslation.sar }} {{vehicleDetails?.amount}}</b></td>
          </tr>
        </tbody>
      </table>

      <hr>
        <h3 style="text-align: end; font-weight: bold;">{{ currentTranslation.total }} {{ currentTranslation.sar }} {{vehicleDetails?.amount}}</h3>
      </div>
    </div>
    <div style="text-align: center; margin-bottom: 100px;">

      <h6 style="margin: 0 15px;">Powered by</h6>
      <img src="assets/img/pass-logo.png" width="41" alt="" srcset="">
    </div>
  </div>